module.exports = __webpack_public_path__ + "img/facts-canopy.866b4038.svg";